// הערת מומחה ללקוח (Founder 30/09/26, pro 3525: "התקשורת עם המומחה מנוהלת על ידי הצוות שלו") — free text an admin sets per
// pro in the admin editor (he_professionals.customer_note, scripts/migrate-pro-customer-note.sql). THE ONE door for every
// surface that shows it: the pro page contact card (React), the WhatsApp pro cards (scripts/wa-worker.mjs session cards and
// the proposed template variable). Never format the note anywhere else.
//
// WhatsApp template parameters forbid newlines, tabs, more than 4 consecutive spaces and EMPTY values → the note is always
// normalised to ONE line here, capped, and an empty note returns null (callers then pick the variant WITHOUT the note).

export const CUSTOMER_NOTE_MAX = 160;

/** The normalised one-line note, or null when there is nothing to show. */
export function proCustomerNote(raw) {
  if (raw == null) return null;
  let s = String(raw).replace(/[\r\n\t]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/\*+/g, '').trim();
  if (!s) return null;
  if (s.length > CUSTOMER_NOTE_MAX) s = s.slice(0, CUSTOMER_NOTE_MAX - 1).replace(/\s+\S*$/, '') + '…';
  return s;
}

/** The line a WhatsApp session card appends to its body ("ℹ️ <note>"), or '' when there is no note. */
export function proCustomerNoteWaLine(raw) {
  const n = proCustomerNote(raw);
  return n ? `ℹ️ ${n}` : '';
}
